import React, { useState, useRef } from "react";
import { Link } from "gatsby";

import DropdownItem from "./dropdown-item";
import SimpleItem from "./nav-simple-item";

import useOutsideClick from "../../hooks/useOutsideClick";

const DropdownMenu = ({ headerLinks, isIndexPage }) => {
  const [expanded, setExpanded] = useState(null);

  const dropdownRef = useRef();
  useOutsideClick(dropdownRef, () => {
    if (expanded) {
      setExpanded(false);
    }
  });

  let lastMinuteButton;
  if (isIndexPage) {
    lastMinuteButton = (
      <a href="#last-minute" className="btn btn-primary">
        Last minute!
      </a>
    );
  } else {
    lastMinuteButton = (
      <Link to="/huvilat/tarjoukset-last-minute" className="btn btn-primary">
        Last minute!
      </Link>
    );
  }

  return (
    <ul ref={dropdownRef} className="navbar-nav ml-auto">
      {headerLinks.map(item => {
        if (item.type === "dropdown") {
          return (
            <DropdownItem
              to={item.to}
              key={item.title}
              items={item.items}
              title={item.title}
              className=""
              isExpanded={(to, items) =>
                to === expanded || items.some(link => link.to === expanded)
              }
              onClick={to => {
                if (to !== expanded) {
                  setExpanded(to);
                } else {
                  setExpanded(null);
                }
              }}
            />
          );
        } else {
          return (
            <SimpleItem
              key={item.title}
              title={item.title}
              to={item.to}
            ></SimpleItem>
          );
        }
      })}
      <li className="nav-item mt-3 mt-lg-0 ml-lg-3 d-lg-none d-xl-inline-block">
        {lastMinuteButton}
      </li>
    </ul>
  );
};

export default DropdownMenu;
